import { ApiProblem } from '@/api/http';
import i18n, { currentLanguage } from '@/i18n';

/**
 * Текст ошибки API на языке интерфейса (ADR-0008).
 *
 * Бэкенд пишет сообщения по-русски, и они бывают конкретнее общего перевода
 * («У клиента уже есть точка «РЦ Вешки»» против «Такая точка уже есть»). Поэтому:
 * - русский интерфейс — текст сервера как есть;
 * - другой язык — перевод по `code`, а если его нет — всё равно текст сервера.
 */
export function problemMessage(error: unknown): string {
  if (!(error instanceof ApiProblem)) return i18n.t('common.unknownError');
  if (error.code === 'network') return i18n.t('errors.network');
  if (currentLanguage() === 'ru') return error.userMessage;
  const key = `errors.${error.code}`;
  if (i18n.exists(key)) return i18n.t(key);
  if (error.code === 'server') return i18n.t('errors.server', { status: error.status });
  return error.userMessage;
}
